import { URLS } from 'common/urls';
import buildV2Authorization from 'common/utils/buildV2Authorization';
import { UserSelector } from 'redux/selectors/UserSelector';
import {
    FETCH_MEDIA_LIBRARY,
    RESET_MEDIA_LIBRARY
} from 'redux/actions/actionTypes';

/**
 * Fetch media library with grouping and filters
 * @param {Object} params - Query parameters
 * @param {string} params.group_by - 'month' or 'year'
 * @param {string} params.order - 'newest' or 'oldest'
 * @param {number} params.page - Page number
 * @param {number} params.page_size - Items per page
 * @param {number} params.journal_id - Optional journal filter
 */
export const fetch = (params = {}) => (dispatch, getState) => {
    const url = URLS.API.MEDIA_LIBRARY.ROOT;
    const user = UserSelector(getState());
    const auth = buildV2Authorization(user);

    const defaultParams = {
        group_by: 'month',
        order: 'newest',
        page: 1,
        page_size: 20,
        ...params
    };

    return dispatch({
        type: FETCH_MEDIA_LIBRARY,
        payload: {
            request: {
                url,
                method: 'GET',
                params: defaultParams,
                headers: {
                    Authorization: auth
                }
            }
        }
    });
};

/**
 * Reset media library state
 */
export const reset = () => (dispatch) => {
    return dispatch({
        type: RESET_MEDIA_LIBRARY
    });
};
